import type { NotificationInstance } from 'antd/es/notification/interface'

export interface NotificationStyles {
  notice: string
  iconInfo: string
  iconSuccess: string
  iconError: string
  iconWarning: string
  actions: string
}

interface NotificationBridge {
  notification: NotificationInstance
  styles: NotificationStyles
}

let bridge: NotificationBridge | null = null

export const registerNotificationBridge = (value: NotificationBridge): void => {
  bridge = value
}

export const getNotificationBridge = (): NotificationBridge | null => bridge
